import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Footer from '../components/Footer'
import Header from '../components/Header'
import favicon from '../pages/assets/favicon.ico'
import './index.css'
import './fonts.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      htmlAttributes={{
        lang: 'en'
      }}
      title="iFeelSmart, Making TV Smarter"
      meta={[
        { name: 'description', content: 'iFeelSmart designs, develops and deploys the most advanced next generation User Interface for SmartTV, Set Top Boxes, Companion screens, blending Live TV content (IPTV, Cable, Satellite) with the wide flow of OTT content, Applications and Games coming from Internet. Our TV solutions are available on Android, AndroidTV and Linux. Our companion apps are running on Android and iOS It is still a TV, a better TV, more than a TV' },
        { name: 'keywords', content: 'IFS, IPTV, UI, UX, User Interface, User Experience, Middleware, OTT, Android, AndroidTV, design, broadcaster-friendly, SmartTV, Connected TV, Companion screen, Companion app, Second Screen' },
      ]}
      link={[
        { rel: 'shortcut icon', type: 'icon', href: `${favicon}` }
    ]}
    />
    <Header />
    <div
      style={{
        margin: '0 auto',
        // maxWidth: 960,
        // padding: '0px 1.0875rem 1.45rem',
        paddingTop: 60,
      }}
    >
      {children()}

    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js